<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card>
      <ODialogBar
        title="Exportar Heartbeats"
        @close="$refs.dialog.$dismiss()"
      />
      <v-card-text class="pa-6 scroll-y">
        <OCol>
          <div>
            <v-text-field
              label="A partir do HB (obrigatório)"
              v-model="fromHbId"
            />
          </div>
          <div>
            <v-text-field label="Até o HB (opcional)" v-model="untilHbId" />
          </div>
        </OCol>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-btn text large @click="$refs.dialog.$dismiss()">
          Cancelar
        </v-btn>
        <v-spacer />
        <v-btn text large color="primary" @click="doExport">
          <v-icon>mdi-download</v-icon>
          Baixar
        </v-btn>
        <v-spacer />
        <v-btn text large color="primary" @click="doInspect">
          <v-icon>mdi-magnify</v-icon>
          Abrir no Inspector
        </v-btn>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import { go } from '@/models'
import { saveBlobAs } from 'oderon-vue/utils'

import Vue from 'vue'

export const Range = new Vue({
  data() {
    return { clientId: null, start: null, end: null }
  },
  methods: {
    markStart(clientId, start) {
      if (clientId != this.clientId) {
        this.clientId = clientId
        this.end = null
      }
      this.start = start
    },
    markEnd(clientId, end) {
      if (clientId != this.clientId) {
        this.clientId = clientId
        this.start = null
      }
      this.end = end
    }
  }
})

export default {
  data() {
    return {
      clientId: null,
      fromHbId: null,
      untilHbId: null
    }
  },
  methods: {
    open(clientId) {
      this.clientId = clientId

      if (Range.clientId == this.clientId) {
        this.fromHbId = Range.start
        this.untilHbId = Range.end
      }
      // this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async doExport() {
      let { clientId, fromHbId, untilHbId } = this
      let ps = { fromHbId, untilHbId }
      let { blob, filename } = await go.download(`hb-export/${clientId}`, ps)
      saveBlobAs(blob, filename)
    },

    doInspect() {
      const { clientId, fromHbId, untilHbId } = this
      const qs = go.toQueryString({ clientId, fromHbId, untilHbId })
      window.open('/#/rawdata/inspector?' + qs)
    }
  }
}
</script>

<style lang="sass"></style>
